/**
 * @author        quanquan
 * @dateTime      2021-01-04 13:43:15
 * @description   Common state
 */

export default {
  appLoading: false,
  token: '',
  accInfo: {},
  resList: [],
  showSubApp: false,
  subApp: [],
  /**
   * Tag list
   */
  tagViewList: [],
  /**
   * Current tag item
   */
  currentTagItem: {},
  /**
   * Cache parent path
   */
  currentParentPath: [],
  /**
   * Currently selected menu data
   */
  currentMenuData: [],

  globalAnimation: '',
  globalParams: {

  },
  // 用户相关信息特别备注
  globalInfo: {

  },
  // 中心店信息
  centerStore: {

  },
  helpParams: {
    reId: '',
    reUrl: ''
  },
  isErp: 0
}



// WEBPACK FOOTER //
// ./src/js/conf/home/store/common/state.js